import { http } from '@/http/index'

async function deleteVideo(videoId) {
	return http.delete(`/posts-videos/${videoId}`)
}

export { deleteVideo }
